import { gql } from '@apollo/client';

export const viewReservationAdmin = gql`query viewReservationAdmin($id: Int!) {
  viewReservationAdmin(id: $id) {
    id
    listId
    hostId
    guestId
    checkIn
    checkOut
    listTitle
    guestServiceFee
    hostServiceFee
    reservationState
    total
    basePrice
    delivery
    currency
    paymentMethodId
    confirmationCode
    createdAt
    updatedAt
    securityDeposit
    claimAmount
    claimPayout
    claimRefund
    bookingType
    dayDifference
    discount
    discountType
    startTime 
    endTime
    hostServiceFeeType
    hostServiceFeeValue
    guestServiceFeeType
    guestServiceFeeValue
    dynamicListTitle
    dynamicPromoCodeDetails
    promoCode
    promoDiscount
    promoCodeType
    promoCodeDescription
    listData {
      id
      title
      bookingType
    }
    hostData {
      profileId
      firstName
      lastName
      countryCode
      phoneNumber
    }
    hostPayout {
      id
      payEmail
    }
    hostTransaction {
      id
      reservationId
    }
    guestData {
      profileId
      firstName
      lastName
      countryCode
      phoneNumber
    }
    transaction {
      id
      payerId
      payerEmail
      receiverEmail
      receiverId
      paymentType
      total
      currency
      transactionId
    }
    refundStatus {
      id
      receiverEmail
      total
      currency
      reservationId
    }
    cancellationDetails {
      id
      reservationId
      refundToGuest
      payoutToHost
      guestServiceFee
      hostServiceFee
      total
      currency
      status
      createdAt
      cancellationPolicy
      cancelledBy
      promoDiscount
      promoCodeType
    }
    hostUser {
      encryptEmail
    }
    guestUser {
      encryptEmail
    }
    bookingSpecialPricing {
      id
      reservationId
      blockedDates
      isSpecialPrice
    }
    status
  }
}`;